import React from 'react';
import AiQuery from '../components/ai/ai';

export default function AiPage() {
    return <AiQuery />;
}
